import { Navigate, useNavigate } from "react-router-dom";
import LoginLayout from "../../layouts/login.layout";
import { loginDefaultBanner } from "../../utils/constant/login.constant";
import ContainerHeader from "../../common/ui/ContainerHeader";
import { Image } from "../../common/ui/Image";
import OTPInputBox from "../../common/ui/otp/OTPInputBox";
import ResendOTP from "../../common/ui/otp/ResendOTP";
import { useState } from "react";
import TimeButton from "../../common/ui/time/TimeButton";
import { toastMessage } from "../../utils/helper/myToast";
import { publicResendCode, verifyEmail } from "../../services/public.services";
import { useSelector } from "react-redux";
import { loginSelector } from "../../store/features/loginSlice";
import Button from "@/common/ui/Button";
import { extractDeviceInfo } from "@/utils/helper/browser";
import { loginSuccessAction } from "@/store/actions/login.actions";
import { useAppDispatch } from "@/store/store";
import useClearHistoryAndNavigate from "@/hooks/useClearHistoryandNavigate";

const AccountVerifyPage = () => {
  const [success, setSuccess] = useState({ value: false, data: null });
  const [otp, setOtp] = useState("");
  const [error, setError] = useState("");
  const [resetCount, setResetCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { signupInfo } = useSelector(loginSelector);
  const dispatch = useAppDispatch();
  const clearNavigate = useClearHistoryAndNavigate();

  if (!signupInfo?.emailVerifyToken) {
    // redirect to home page
    return <Navigate to="/" replace />;
  }

  const handleVerifyEmail = async () => {
    setIsLoading(true);
    const browserInfo = await extractDeviceInfo();
    const payload: any = { otp, token: signupInfo?.emailVerifyToken };

    if (browserInfo) {
      payload.browserInfo = { ...browserInfo };
    }

    try {
      const res: any = await verifyEmail(payload);
      if (res?.status === 200) {
        const { message, isError, data, showMessage } = res.data;
        setSuccess({ value: true, data });
        return showMessage && toastMessage(message, isError);
      } else if (res?.response?.status === 401) {
        const { message } = res?.response?.data || {};
        setError(message);
        return;
      } else {
        console.log("Error", res);
        const { message } = res?.response?.data || {};
        if (message) {
          setError(message);
        }
      }
    } catch (err) {
      console.log({ err });
    } finally {
      setIsLoading(false);
    }
  };

  const resendOtp = async () => await publicResendCode({ token: signupInfo?.emailVerifyToken });

  const gotoDashboard = () => {
    if (success.data) dispatch(loginSuccessAction(success.data));
    clearNavigate("/dashboard");
  };

  return (
    <LoginLayout sideBanner={loginDefaultBanner}>
      <div className=" flex flex-col items-center w-[calc(100%-12px)] md:w-full md:max-w-[700px] pb-32 md:pb-0">
        <div className="mt-12 h-fit w-full md:w-[400px] shadow-form p-5 flex flex-col items-center">
          {success?.value ? (
            <>
              <ContainerHeader headingClassName=" text-xl !leading-normal font-black text-text-label" heading="Email verified successfully!" />
              <Image src="/images/done.svg" alt="email-send-image" className=" hover:cursor-pointer" />
              <TimeButton handleClick={gotoDashboard} btnText="Take me to dashboard" text="You will be automatically re-directed to the Lystproof dashboard" />
            </>
          ) : (
            <>
              <ContainerHeader
                handleBack={() => navigate(-1)}
                headingClassName=" text-xl !leading-normal font-black text-text-label"
                heading="Verify your e-mail"
              />
              <Image src="/images/mail-sent.svg" alt="email-send-image" className=" hover:cursor-pointer" />
              <p className=" text-center py-5">
                We have sent a code to <span className=" font-medium">{signupInfo?.maskIdentity}</span>.<br /> Please enter it below.
              </p>
              <div className=" flex flex-col w-full px-2 justify-start">
                <OTPInputBox
                  setCompleteOtp={setOtp}
                  errorMessage={error}
                  resetErrorMessage={() => setError("")}
                  errorTextClassName="md:pl-6"
                  resetCount={resetCount}
                />
                <ResendOTP
                  resendOtpAPI={resendOtp}
                  className="md:px-4"
                  errorMessage={error}
                  resetErrorMessage={() => setError("")}
                  setResetCount={setResetCount}
                />
              </div>

              <Button variant="primary" size="small" className=" mt-5" isFullWidth onClick={handleVerifyEmail} disabled={!otp} isLoading={isLoading}>
                Verify
              </Button>
            </>
          )}
        </div>
      </div>
    </LoginLayout>
  );
};

export default AccountVerifyPage;
